<template>
	<input type="number" :min="min" :max="max" :value="value" @input="onInput" @change="onChange">
</template>

<script>
export default {
	name: 'priceInput',
	props: {
		value: {},
		min: {},
		max: {},
		format: {
			type: String,
			default: 'int', // int, float
		},
	},
	methods: {
		parsePrice(price) {
			const text = `${price}`;
			const regex = this.isFloat ? /[^0-9.-]/g : /[^0-9-]/g;
			let parsedPrice = text.replace(regex, '').trim();
			const parsedPriceLength = parsedPrice.length;
			if (parsedPriceLength > 1 && parsedPrice.charAt(0) === '0') {
				parsedPrice = parsedPrice.substring(1, parsedPriceLength);
			}
			if (parsedPrice !== '') {
				if (this.isFloat) {
					parsedPrice = parseFloat(parsedPrice);
				} else {
					parsedPrice = parseInt(parsedPrice);
				}
			}

			if (Number.isNaN(parsedPrice)) {
				parsedPrice = 0;
			}

			return parsedPrice;
		},
		onInput(event) {
			const value = event.target.value;
			const parsed = this.parsePrice(value);
			this.$emit('input', parsed);
			this.$forceUpdate();
		},
		onChange(event) {
			const value = event.target.value;
			const intValue = (this.isFloat) ? parseFloat(value) : parseInt(value);
			if (value === '') {
				this.$emit('input', 0);
			}
			if (this.min && intValue < this.min) {
				this.$emit('input', this.min);
			} else if (this.max && intValue > this.max) {
				this.$emit('input', this.max);
			}
		},
	},
	computed: {
		isFloat() {
			return this.format === 'float';
		},
	},
};
</script>
